import { OrgPensionSchemeRequest } from './types';
import { BASE } from '@/utils/service-providers';

export const GET_ORGANIZATION_PENSION_SCHEMES = (
  orgPensionSchemeRequest: OrgPensionSchemeRequest,
  liteMode: boolean = false
) => {
  const page = orgPensionSchemeRequest.page ? orgPensionSchemeRequest.page : 1;
  const limit = orgPensionSchemeRequest.limit
    ? orgPensionSchemeRequest.limit
    : 15;
  const params = new URLSearchParams();

  if (orgPensionSchemeRequest?.page) {
    params.set('page', page.toString());
  }
  if (orgPensionSchemeRequest?.limit) {
    params.set('limit', limit.toString());
  }
  if (orgPensionSchemeRequest.rootIds?.length) {
    orgPensionSchemeRequest.rootIds?.forEach(it => {
      params.append('filter[id][]', it);
    });
  }

  if (orgPensionSchemeRequest.rootEntityIds?.length) {
    orgPensionSchemeRequest.rootEntityIds?.forEach(it => {
      params.append('filter[entity_id][]', it);
    });
  }

  if (orgPensionSchemeRequest.reportingPeriodIds?.length) {
    orgPensionSchemeRequest.reportingPeriodIds?.forEach(it => {
      params.append('filter[time_period_id][]', it);
    });
  }
  if (orgPensionSchemeRequest.assetManagerIds?.length) {
    orgPensionSchemeRequest.assetManagerIds?.forEach(it => {
      params.append('filter[entity.managerOrgId][]', it);
    });
  }
  if (orgPensionSchemeRequest.searchKeyword) {
    params.set('filter[entity.name]', orgPensionSchemeRequest.searchKeyword);
  }

  if (orgPensionSchemeRequest.incompleteFutureReportingPeriod) {
    params.set('filter[incomplete_future_reporting_period]', 'true');
  }
  let includes: string;
  if (liteMode) {
    includes = `entity,timePeriod,proportions`;
  } else {
    includes =
      // eslint-disable-next-line max-len
      'entity,timePeriod,children.latestSubmission,children.children.latestSubmission,proportions,children.resourceTags.tag,children.children.resourceTags.tag';
  }
  params.set('include', includes);

  return (
    `/base/organizations/${orgPensionSchemeRequest.orgId}/pension-scheme?` +
    `${params.toString()}`
  );
};

export const POST_PENSION_SCHEME = (orgId: string) => {
  return `/base/organizations/${orgId}/pension-scheme`;
};

export const POST_NEW_REPORTING_PERIOD = (
  orgId: string,
  pensionSchemeId: string
) => {
  return `/base/organizations/${orgId}/pension-scheme/${pensionSchemeId}`;
};

export const PUT_PENSION_SCHEME = (orgId: string, pensionSchemeId: string) => {
  return `/base/organizations/${orgId}/pension-scheme/${pensionSchemeId}`;
};

export const DELETE_PENSION_SCHEME = (
  orgId: string,
  pensionSchemeId: string,
  investmentId: string
) => {
  return `/base/organizations/${orgId}/pension-scheme/${pensionSchemeId}?investmentId=${investmentId}`;
};

export const POST_SERVICE_COST = (orgId: string, pensionSchemeId: string) => {
  return `base/organizations/${orgId}/pension-scheme/${pensionSchemeId}/service-level-cost`;
};

export const DELETE_SERVICE_COST = (
  orgId: string,
  pensionSchemeId: string,
  investmentId: string
) => {
  return (
    `base/organizations/${orgId}/pension-scheme/${pensionSchemeId}/service-level-cost` +
    `?investmentId=${investmentId}`
  );
};

export const PROPORTIONS_ENDPOINT = (orgId: string) => {
  return `${BASE}/organizations/${orgId}/sub-fund-proportions`;
};
